/*
 * @Author:
 * @LastEditTime: 2022-06-09 11:10:23
 * @Description:
 */
import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
// 以下模块已经同意迁移到模块下
// src/modules/layout/layout-wiz/store
import Auth from '../modules/layout/layout-wiz/store/modules/Auth.models'
import System from '../modules/layout/layout-wiz/store/modules/System.models'
import Sites from '../modules/layout/layout-wiz/store/modules/Sites.models'
import Abp from '../modules/layout/layout-wiz/store/modules/Abp.models'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    Auth,
    System,
    Sites,
    Abp,
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  plugins: [createPersistedState()],
})
